import { render, staticRenderFns } from "./zabbixMonitor.vue?vue&type=template&id=4866a41c&scoped=true&"
import script from "./zabbixMonitor.vue?vue&type=script&lang=js&"
export * from "./zabbixMonitor.vue?vue&type=script&lang=js&"
import style0 from "./zabbixMonitor.vue?vue&type=style&index=0&id=4866a41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4866a41c",
  null
  
)

export default component.exports